export default __webpack_public_path__ + "static/media/mainbg.39393076.png";